import areaApi from '@/api/config/areaApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'

async function deleteArea(interfaceId: string, id: string): Promise<void> {
  await areaApi.delete(interfaceId, id)
}

function useDeleteArea() {
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: any) => deleteArea(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.areaZone])
        closeModal()
      },
      onError: (error: AxiosError<any>) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )
}

export default useDeleteArea
